import { useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@london-life/ui/components/dialog';
import type { FlightView as Trip } from '@london-life/contracts';
import { describeError } from '@london-life/errors';
import { api } from '../lib/api';
import { notify } from '../lib/alerts';

// after a ride on a player's train (Rail Co.): one to five stars for the company, once per trip, as Lagos Life's
// rating of a player's bus. The stars are the company's rating in the ticket office.
export function RateTrip({ trip, onClose }: { trip: Trip; onClose: () => void }) {
  const [stars, setStars] = useState(0);
  const [sending, setSending] = useState(false);
  const send = async (value: number) => {
    setStars(value);
    setSending(true);
    try {
      await api.railco.rate({ tripId: trip.id, stars: value });
      notify(`⭐ Thanks! ${trip.jetName} got your ${value} star${value === 1 ? '' : 's'}`);
      onClose();
    } catch (error) {
      notify(describeError(error).message);
      setSending(false);
    }
  };
  return (
    <Dialog
      open
      onOpenChange={(next) => {
        if (!next) onClose();
      }}
    >
      <DialogContent className="city-card city-phone rate-trip">
        <DialogTitle>How was the ride?</DialogTitle>
        <DialogDescription>
          {trip.jetName} · {trip.registration} to {trip.to.name}
        </DialogDescription>
        <div className="rate-trip-stars" role="radiogroup" aria-label="Stars">
          {[1, 2, 3, 4, 5].map((value) => (
            <button
              type="button"
              key={value}
              role="radio"
              aria-checked={stars === value}
              aria-label={`${value} star${value === 1 ? '' : 's'}`}
              className={value <= stars ? 'on' : ''}
              disabled={sending}
              onClick={() => void send(value)}
            >
              ★
            </button>
          ))}
        </div>
        <button type="button" className="flights-terminal" onClick={onClose} disabled={sending}>
          Not now
        </button>
      </DialogContent>
    </Dialog>
  );
}
